/* eslint-disable no-template-curly-in-string */
export const GLOBAL_ERRORMESSAGES_LABEL = 'global.errorMessages';
export const ACCOUNT_PAYMENTGC_LABEL = 'account.paymentGC';
export const lblTcpCouponUsedAlready = 'lbl_errorMessagess_TCP_COUPON_USED_ALREADY';
export const lblErrorMessages2270 = 'lbl_errorMessages_2270';
export const lblErrorMessages2080 = 'lbl_errorMessages_2080';
export const lblErrorMessages2030 = 'lbl_errorMessages_.2030';
export const lblErrLogonIdAlreadyExist = 'lbl_errorMessages_ERR_LOGONID_ALREDY_EXIST';
export const lblErrorMessages1005 = 'lbl_errorMessages_1005';
export const lblErrorMessages2010 = 'lbl_errorMessages_.2010';
export const lblErrorMessages2210 = 'lbl_errorMessages_.2210';
export const lblErrOrderNotFound = 'lbl_errorMessages_ERR_ORDER_NOT_FOUND';
export const lblErrorMessagesTCPGC06 = 'lbl_errorMessages_TCPGC06';
export const lblErrDuplicateGC = 'lbl_errorMessages_ERR_DUPLICATE_GIFT_CARD';
export const lblErrDuplicateCard = 'lbl_errorMessages_ERR_DUPLICATE_CARD';
export const lblErrPayCardNumberInvalid = 'lbl_errorMessages_ERR_PAY_CARD_NUMBER_INVALID';
export const lblErrormessages500 = 'lbl_errorMessages_500';
export const lblErrPromotionCodeInvalid = 'lbl_errorMessages_ERR_PROMOTION_CODE_INVALID';
export const lblErrMissingCmdParameter = 'lbl_errorMessages_ERR_MISSING_CMD_PARAMETER';
export const lblTcpPromotionLoyaltyCouponNotInWallet =
  'lbl_errorMessages_TCP_PROMOTION_LOYALTY_COUPON_NOT_IN_WALLET';
export const lblTcpPromotionLoyaltyAvailableOnlyForRegisteredUser =
  'lbl_errorMessages_TCP_PROMOTION_LOYALTY_AVAILABE_ONLY_FOR_REGISTERED_USER';
export const lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLE =
  'lbl_errorMessages_TCP_PROMOTION_NOT_TRANSFERABLE';
export const lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLELOYALTY =
  'lbl_errorMessages_TCP_PROMOTION_NOT_TRANSFERABLE_LOYALTY';
export const lblErrorMessagesApplyCouponCustomerRedemptionLimit =
  'lbl_errorMessages_ERR_APPLY_COUPON_CUSTOMER_REDEMPTION_LIMIT';
export const lblErrorMessagesTCPPROMOTIONAVAILABLEONLYFORREGISTEREDUSER =
  'lbl_errorMessages_TCP_PROMOTION_AVAILABLE_ONLY_FOR_REGISTERED_USER';
export const lblErrUserAuthority = 'lbl_errorMessages_ERR_USER_AUTHORITY';
export const lblPaypalCCErrorUsCrossNotSupported =
  'lbl_errorMessages_PAYPAL_CC_ERROR_CODE_US_CROSS_SITE_ADDRESS_NOT_SUPPORTED';
export const lblPaypalCCErrorCaCrossNotSupported =
  'lbl_errorMessages_PAYPAL_CC_ERROR_CODE_CANADA_CROSS_SITE_ADDRESS_NOT_SUPPORTED';
export const lblPaypalCcErrorCodeShippingNameUnavailable =
  'lbl_errorMessages_PAYPAL_CC_ERROR_CODE_SHIPPING_LASTNAME_OR_FIRSTNAME_NOT_AVAILABLE_IN_PAYPAL_ACCOUNT';
export const lblPaypalCcErrorCodeBillingNameUnavailable =
  'lbl_errorMessages_PAYPAL_CC_ERROR_CODE_BILLING_LASTNAME_OR_FIRSTNAME_NOT_AVAILABLE_IN_PAYPAL_ACCOUNT';
export const lblErrorMessagesTCP02 = 'lbl_errorMessages_TCP02';
export const lblErrorMessagesSvs20 = 'lbl_errorMessages_SVS20';
export const lblErrInvalidPinCard = 'lbl_errorMessages_ERR_INVALID_PIN_CARD';
export const lblErrorMessagesCMN0409E = 'lbl_errorMessages_CMN0409E';
export const lblErrGiftcardSvs15 = 'lbl_errorMessages_ERR_GIFTCARD_SVS15';
export const lblErrorMessagesSvs15 = 'lbl_errorMessages_SVS15';
export const lblErrorMessagesSvs16 = 'lbl_errorMessages_SVS16';
export const lblGCRecaptchaFailed = 'lbl_errorMessages_GIFT_CARD_RECAPTCHA_FAILED';
export const lblErrGCSvs20 = 'lbl_errorMessages_ERR_GIFTCARD_SVS20';
export const lblPaypalCcAuthenticationUserCanc =
  'lbl_errorMessages_PAYPAL_CC_ERROR_CODE_AUTHENTICATION_USER_CANCELED';
export const lblPaypalCcGenericError = 'lbl_errorMessages_PAYPAL_CC_ERROR_CODE_GENERIC_ERROR';
export const lblPaypalCcFailedTransTable =
  'lbl_errorMessages_PAYPAL_CC_ERROR_CODE_FAILED_UPDATE_PAYPAL_TRANS_TABLE';
export const lblCardinalCommerceError =
  'lbl_errorMessages_PAYPAL_CC_ERROR_CODE_CARDINAL_COMMERCE_ERROR';
export const lblTcpMixOrderNotAcceptedNow = 'lbl_errorMessages_TCP_MIX_ORDER_NOT_ACCEPTED_NOW';
export const lblTcpBopisOrderNotAcceptedNow = 'lbl_errorMessages_TCP_BOPIS_ORDER_NOT_ACCEPTED_NOW';
export const lblInvalidParam = 'lbl_errorMessages_INVALID_PARAM';
export const lblMandatoryParamNotPassed = 'lbl_errorMessages_MANDATORY_PARAM_NOT_PASSED';
export const lblErrBagParams = 'lbl_errorMessages_ERR_BAD_PARMS';
export const lblOosOrUnavailable = 'lbl_errorMessages_OOS_OR_UNAVAILABLE';
export const lblErrorMessagesSvs07 = 'lbl_errorMessages_SVS07';
export const lblErrorMessagesSvs08 = 'lbl_errorMessages_SVS08';
export const lblTcpErrorCodeCardDeclined = 'lbl_errorMessages_TCP_ERROR_CODE_CARD_DECLINED';
export const lblErrorMessagesDefault = 'lbl_errorMessages_DEFAULT';
export const lblTcpPaymentProcessingErr = 'lbl_errorMessages_TCP_PAYMENT_PROCESSING_ERR';
export const lblDbgApiDoPaymentBadXdate = 'lbl_errorMessages_DBG_API_DO_PAYMENT_BAD_XDATE';
export const lblErrTaxwareUtlGeneralCc = 'lbl_errorMessages_ERR_TAXWARE_UTL_GENERAL_CC';
export const lblCodeNotApplicable = 'lbl_errorMessages_CODE_NOT_APPLICABLE';
export const lblCodeNotApplicableCa = 'lbl_errorMessages_CODE_NOT_APPLICABLE_Ca';
export const lblErrUsZipcodeInvalid = 'lbl_errorMessages_ERR_US_ZIPCODE_INVALID';
export const lblErrTaxwareUtlRc = 'lbl_errorMessages_ERR_TAXWARE_UTL_RC';
export const lblErrorMessagesTcp06 = 'lbl_errorMessages_TCP06';
export const lblErrorMessagesTcp07 = 'lbl_errorMessages_TCP07';
export const lblInternalServerError = 'lbl_errorMessages_INTERNAL_SERVER_ERROR';
export const lblErrInternalServerError = 'lbl_errorMessages_ERR_INTERNAL_SERVER_ERROR';
export const lblErrorMessagesCWXFR0230E = 'lbl_errorMessages_CWXFR0230E';
export const lblDomHistoryErrorDetected = 'lbl_errorMessages_DOM_HISTORY_ERROR_DETECTED';
export const lblErrRdnAlreadyExist = 'lbl_errorMessages_ERR_RDN_ALREADY_EXIST';
export const lblAssociateIdNotExist = 'lbl_errorMessages_ASSOCIATE_ID_NOT_EXIST';
export const lblAssociateIdDoesNotExist = 'lbl_errorMessages_ASSOCIATE_ID_DOES_NOT_EXIST';
export const lblAssociateIdNotValid = 'lbl_errorMessages_ASSOCIATE_ID_NOT_VALID';
export const lblAssociateIdNotExistForUser =
  'lbl_errorMessages_ASSOCIATE_ID_NOT_EXIST_FOR_THE_USER';
export const lblInvalidCurrentPwd = 'lbl_errorMessages_INVALID_CURRENT_PASSWORD';
export const lblErrMaxLimitReached = 'lbl_errorMessages_ERR_MAX_LIMIT_REACHED';
export const lblInvalidPrescreenCode = 'lbl_errorMessages_INVALID_PRESCREEN_CODE';
export const lblErrorMessages13007 = 'lbl_errorMessages_13007';
export const lblMyAccountPointsClaim2 = 'lbl_errorMessages_MY_ACCOUNT_POINTS_CLAIM_2';
export const lblMyAccountPointsClaim3 = 'lbl_errorMessages_MY_ACCOUNT_POINTS_CLAIM_3';
export const lblMyAccountPointsClaim4 = 'lbl_errorMessages_MY_ACCOUNT_POINTS_CLAIM_4';
export const lblSystemNotAvailable = 'lbl_errorMessages_ERR_SYSTEM_NOT_AVAILABLE';
export const lblErrOrdEmailMismatch = 'lbl_errorMessages_ERR_ORD_EMAIL_MISMATCH';
export const lblErrorMessagesTCPBPO01 = 'lbl_errorMessages_TCPBPO01';
export const lblBopisNotAvailable = 'lbl_errorMessages_BOPIS_NOT_AVAILABLE';
export const lblNoStoresFound = 'lbl_errorMessages_NO_STORES_FOUND';
export const lblErrSomethingWrong = 'lbl_errorMessages_ERR_SOMETHING_WRONG';
export const lblErrorOccured = 'lbl_errorMessages_ERROR_OCCURED';
export const lblErrGiftListNameTooLong = 'lbl_errorMessages_ERR_GIFTLIST_NAME_TOO_LONG';
export const lblErrItemCatelogEntryNotFound =
  'lbl_errorMessages_ERR_GIFTLIST_ITEM_CATALOGENTRY_NOT_FOUND';
export const lblErrorMessagesOobError = 'lbl_errorMessages_OOB_ERROR';
export const lblWicRtpsCouponNotApplied = 'lbl_errorMessages_WIC_RTPS_COUPON_NOT_APPLIED';
export const lblRtpsInactivePayment = 'lbl_errorMessages_RTPS_INACTIVE_PAYMENT';
export const lblCvvRequestFailedWithCvvError =
  'lbl_errorMessages_TCP_CVV_REQUEST_FAILED_WITH_CREDIT_CARD_CVV_ERROR';
export const lblErrCredentialsExpired = 'lbl_errorMessages_ERR_CREDENTIALS_EXPIRED';
export const lblCvvRequestFailedWithAuthError =
  'lbl_errorMessages_TCP_CVV_REQUEST_FAILED_WITH_CREDIT_CARD_AUTH_ERROR';
export const lblInvalidRecaptcha = 'lbl_errorMessages_INVALID_RECAPTCHA';
export const lblEmptyRecaptcha = 'lbl_errorMessages_EMPTY_RECAPTCHA';
export const lblTcpPaymentInsufficient = 'lbl_errorMessages_TCP_PAYMENT_INSUFFICIENT';
export const lblErrmaxItemcount = 'lbl_errorMessages_ERR_MAX_ITEMCOUNT';
export const lblErrInvalidAddr = 'lbl_errorMessages_ERR_INVALID_ADDR';
export const lblErrorMessagesVidesErrro1 = 'lbl_errorMessages_VIDES_ERRRO_1';
export const lblErrorMessagesVidesErrro2 = 'lbl_errorMessages_VIDES_ERRRO_2';
export const lblTcpPromotionCouponExpired = 'lbl_errorMessages_TCP_PROMOTION_COUPON_EXPIRED';
export const lblCouponGeneric = 'lbl_errorMessages_COUPON_GENERIC';
export const lblPromotionNotAvailableThisTime =
  'lbl_errorMessages_ERR_PROMOTION_NOT_AVAILABLE_AT_THIS_TIME';
export const lblErrMoreThan15ItemsInCart = 'lbl_errorMessages_ERR_MORE_THAN_15_ITEM_IN_CART_ERROR';
export const lblApiCantResolveFemcenter = 'lbl_errorMessages_API_CANT_RESOLVE_FFMCENTER';
export const lblApiBadInv = 'lbl_errorMessages_API_BAD_INV';
export const lblApiBadInvCheckout = 'lbl_errorMessages_CHECKOUT_API_BAD_INV';
export const lblVenmoGeneralErr = 'lbl_errorMessages_VENMO_GENERAL_ERROR';
export const lblTcpAuthRequestFailedAvs =
  'lbl_errorMessages_TCP_AUTH_REQUEST_FAILED_WITH_PLCC_AVS_ERROR';
export const lblApiCartOosItem = 'lbl_errorMessages_API_CART_OOS_ITEM';
export const lblProcessRequestError = 'lbl_errorMessages_PROCESS_REQUEST_ERROR';
export const lblAddressNotEligible = 'lbl_errorMessages_ADDRESS_NOT_ELIGIBLE';
export const lblNoAddAvailable = 'lbl_errorMessages_NO_ADDR_AVAILABLE';
export const lblErrorMessages9001 = 'lbl_errorMessages_9001';
export const lblErrMoreThan300Total = 'lbl_errorMessages_ERR_MORE_THAN_300_TOTAL_IN_CART_ERROR';
export const lblTcpSflMaxLimitError = 'lbl_errorMessages_TCP_SFL_MAX_LIMIT_ERROR';
export const lblGiftCardInsufficientFund = 'lbl_errorMessages_GIFT_CARD_INSUFFICIENT_FUND';
export const lblErrorMessagesSvs04 = 'lbl_errorMessages_SVS04';
export const lblBopisDomInvUnavailable = 'lbl_errorMessages_BOPIS_DOM_INVENTORY_UNAVAILABLE';
export const lblQvSorryMessage = 'lbl_quick_view_sorry_message';
export const lblQuickViewError = 'lbl_quick_view_error';
export const lblErrResendOrderEmail = 'lbl_errorMessages_ERR_RESEND_ORDER_EMAIL';
export const lblErrResendOrderNotFound = 'lbl_errorMessages_ERR_RESEND_ORDER_DETAIL_NOT_FOUND';
export const lblErrResendConfirmationLimitReached =
  'lbl_errorMessages_ERR_RESEND_CONFIRMATION_LIMIT_REACHED';
export const lblErrBenefitsNotApplicable = 'lbl_errorMessages_Benefits_Not_Applicable';
export const lblErrStateDoesNotMatchShipmentOption =
  'lbl_errorMessages_ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION';
export const lblTcpPromotionCouponAlreadyUsed =
  'lbl_errorMessages_TCP_PROMOTION_COUPON_ALREADY_USED';
export const lblTcpPromotionPlaceCashCouponExpired =
  'lbl_errorMessages_TCP_PROMOTION_PLACE_CASH_COUPON_EXPIRED';
export const lblTcpPromotionCouponEmptyCart =
  'lbl_errorMessages_TCP_PROMOTION_COUPON_ON_EMPTY_CART';
export const lblTcpEmptyCartBenefitsCoupon =
  'lbl_errorMessages_Tcp_Empty_Cart_Benefits_Coupon_Apply';
export const lblTcpPromotionPlccAvailableAdsplacecardUser =
  'lbl_errorMessages_TCP_PROMOTION_PLCC_AVAILABE_ONLY_FOR_ADSPLACECARD_USER';
export const lblErrInvalidCity = 'lbl_errorMessages_ERR_INVALID_CITY';
export const lblApiCantResolveFfmcenterShort = 'lbl_errorMessages_API_CANT_RESOLVE_FFMCENTER_SHORT';
export const lblErrorOccuredTryAgain = 'lbl_errorMessages_AN_ERROR_OCCURRED_PLEASE_TRY_AGAIN';
export const lblEnterValidExpirationDate = 'lbl_errorMessages_PLEASE_ENTER_A_VALID_EXPIRATION_DATE';
export const lblTryLoggingInAgain =
  'lbl_errorMessages_TRY_LOGGING_OUT_AND_LOG_BACK_IN_OR_TRY_AGAIN_LATER';
export const lblAfterpayCheckoutError = 'lbl_errorMessages_AFTERPAY_CHECKOUT_ERROR';
export const lblBtsErrorMsgHeader = 'bts_error_message_header';
export const lblAfterpayCheckoutGcError = 'lbl_errorMessages_AFTERPAY_CHECKOUT_GC_ERROR';
export const lblApiCantResolveFfmCenterOos = 'lbl_errorMessages_API_CANT_RESOLVE_FFMCENTER_OOS';
export const lblApiCantResolveFfmPartialInstockMsg1 =
  'lbl_errorMessages_API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG1';
export const lblApiCantResolveFfmPartialInstockMsg2 =
  'lbl_errorMessages_API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG2';
export const lblParamCatIdBossIneligible = 'lbl_errorMessages_PARAM_catEntryId_BOSS_INELIGIBLE';
export const lblUsidUnauthorized = 'lbl_errorMessages_USID_UNAUTHORIZED';
export const lblTcpPromotionLoyaltyNotMet =
  'lbl_errorMessages_TCP_PROMOTION_LOYALTY_THRESHOLD_NOT_MET';
export const lblTcpPromotionPlaceCashNotMet =
  'lbl_errorMessages_TCP_PROMOTION_PLACECASH_THRESHOLD_NOT_MET';
export const lblErrBillingAddressMissing = 'lbl_errorMessages_ERR_BILLING_ADDRESS_MISSING';
export const lblErrBillingAddressInternationalPlcc =
  'lbl_errorMessages_ERR_INTERNATIONAL_BILLING_ADDRESS_PLCC';
export const lblInsufficientInventoryCode = 'lbl_errorMessages_INSUFFICIENT_INVENTORY_CODE';
export const lblMobileAppCodeNotApplicable = 'lbl_errorMessages_MOBILE_APP_CODE_NOT_APPLICABLE';
export const lblAppliedMobileCodeNotApplicable =
  'lbl_errorMessages_APPLIED_MOBILE_CODE_NOT_APPLICABLE';
export const lblErrInvalidProductItem = 'lbl_errorMessages_ERR_INVALID_PRODUCT_ITEM';
export const lblErrProductItemNotFound = 'lbl_errorMessages_ERR_PRODUCT_ITEM_NOT_FOUND';
export const lblErrInvalidShippingMethodId = 'lbl_errorMessages_ERR_INVALID_SHIPPING_METHOD_ID';
export const lblErrBasketQuotaExceeded = 'lbl_errorMessages_ERR_BASKET_QUOTA_EXCEEDED';
export const lblErrMaxShipmentsReached = 'lbl_errorMessages_ERR_MAX_SHIPMENTS_REACHED';
export const lblApplePayCouponNotApplicable = 'lbl_errorMessages_APPLE_PAY_COUPON_NOT_APPLICABLE';
export const lblErrPromotionCodeValueCuplicateOnhold =
  'lbl_errorMessages_ERR_PROMOTION_CODE_VALUE_DUPLICATE_ONHOLD';
export const lblBossInvNotApplicable = 'lbl_errorMessages_BOSS_INV_NOT_AVAILABLE';
export const lblErrInvNotApplicable = 'lbl_errorMessages_ERR_INVENTORY_NOT_AVAILABLE';
export const lblErrorMessagesTimeout = 'lbl_errorMessages_TIMEOUT';
export const lblErrFailedTriggeringUserSharecart =
  'lbl_errorMessage_ERR_FAILED_TRIGGER_USER_SHARE_CART';
export const lblErrShareCartItemsOos = 'lbl_errorMessage_ERR_SHARE_CART_GET_ITEMS_OOS';
export const lblErrShareCartGetItemsFailed = 'lbl_errorMessage_ERR_SHARE_CART_GET_ITEMS_FAILED';
export const lblErrFailedShareCartNoId = 'lbl_errorMessage_ERR_FAILED_SHARE_CART_NOREQIDFOUND';
export const lblMaxShareCartRched = 'lbl_errorMessage_ERR_MAX_SAVE_SHARE_CART_REACHED';
export const lblPaypalAddressError = 'lbl_errorMessage_ERR_PAYPAL_LOOKUP_INVALID_SHIPPING_ADDERSS';
export const lblErrAddEditCreditCard = 'lbl_errorMessages_ERR_ADD_EDIT_CREDIT_CARD';
const GIFTCARD_AUTHORIZATION_FAILED = 'Giftcard authorization declined.';
const PIN_INCORRECT_MESSAGE =
  'Oops... The card and/or pin number you entered is incorrect. Please try again.';
const OOS_ERR_MESSAGE =
  'Sorry, the item(s) you tried to add to your shopping bag may either be out of stock or not available in the quantity you requested at the selected store.';
const NOT_AVAILABLE_MSG =
  'Sorry, one or more items you are trying to purchase are either out of stock or not available in the quantity you requested.';

export const ErrorLabels = {
  global: {
    errorMessages: {
      [lblMaxShareCartRched]:
        '<div style="color: #000;font-family: Nunito;font-size: 12px;padding-top: 4px;"><span style="font-weight: 700;">You have reached the maximum number of shares for today.</span></div>',
      [lblTcpCouponUsedAlready]:
        'One or more of your coupons have already been redeemed. Please remove the coupon(s) and try again.',
      [lblErrorMessages2270]: 'Password must include at least 1 uppercase character(s).',
      [lblErrorMessages2080]: 'Password must include at least 1 special character(s).',
      [lblErrorMessages2030]:
        'Oops! The email or password you’ve entered is incorrect. Password must be at least 8 characters long and have at least 1 uppercase, 1 number and 1 special character.',
      [lblErrLogonIdAlreadyExist]: 'The email address you entered matches an existing account.',
      [lblErrorMessages1005]: 'You have entered an invalid card number.',
      [lblErrorMessages2010]:
        'Oops! The email or password you’ve entered is incorrect. Password must be at least 8 characters long and have at least 1 uppercase, 1 number and 1 special character.',
      [lblErrorMessages2210]: 'Please review the password requirements and try again',
      [lblErrOrderNotFound]: 'Sorry, that order was not found. Please try again.',
      [lblErrorMessagesTCPGC06]: 'Please try again.',
      [lblErrDuplicateGC]:
        'That gift card number has already been applied to your order. Please enter a different gift card number.',
      [lblErrDuplicateCard]: 'Please check if the card is already in use.',
      [lblErrPayCardNumberInvalid]:
        'The credit card number is not valid. Type the number of the credit card in the Credit card number field and try again.',
      [lblErrormessages500]: 'Uh oh... System error. Please try again.',
      [lblErrPromotionCodeInvalid]: 'Sorry, this code is invalid. Please verify it and try again.',
      [lblErrMissingCmdParameter]:
        "My Place Rewards cannot be applied when you're shopping as a guest. Please log in.",
      [lblTcpPromotionLoyaltyCouponNotInWallet]:
        'The code you used is not applicable. Note: My Place Rewards are not transferable between accounts. Please verify your code and try again.',
      [lblTcpPromotionLoyaltyAvailableOnlyForRegisteredUser]:
        'Please login to your account to apply this coupon.',
      [lblErrorMessagesTCPPROMOTIONAVAILABLEONLYFORREGISTEREDUSER]:
        'Please login to your account to apply this coupon.',
      [lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLE]:
        'The code you used is not applicable. Coupon is not transferable between accounts. Please verify your code and try again',
      [lblErrorMessagesTCPPROMOTIONNOTTRANSFERABLELOYALTY]:
        'The code you used is not applicable. My Place Rewards are not transferable between accounts. Please verify your code and try again.',
      [lblErrorMessagesApplyCouponCustomerRedemptionLimit]:
        'You have reached the usage limit for this coupon',
      [lblErrUserAuthority]: 'The user does not have the authority to run this command.',
      [lblPaypalCCErrorUsCrossNotSupported]:
        "There's an error with this transaction. Please enter a valid shipping or billing address.",
      [lblPaypalCCErrorCaCrossNotSupported]:
        'You cannot use a United States based Paypal account when shipping to Canada, and conversely you cannot use a Canadian based Paypal account when shipping to the United States.',
      [lblPaypalCcErrorCodeShippingNameUnavailable]:
        'Please update the shipping information on your Pay-Pal account, including first and last name.',
      [lblPaypalCcErrorCodeBillingNameUnavailable]:
        'Please update the billing information on your Pay-Pal account, including first and last name.',
      [lblErrorMessagesTCP02]: PIN_INCORRECT_MESSAGE,
      [lblErrorMessagesSvs20]: GIFTCARD_AUTHORIZATION_FAILED,
      [lblErrInvalidPinCard]: PIN_INCORRECT_MESSAGE,
      [lblErrorMessagesCMN0409E]: PIN_INCORRECT_MESSAGE,
      [lblErrGiftcardSvs15]: PIN_INCORRECT_MESSAGE,
      [lblErrorMessagesSvs15]:
        'Oops... The card and/or pin number you entered is incorrect. Please try again',
      [lblErrorMessagesSvs16]:
        'We are sorry; however, the Gift Card isn’t currently valid. Please try again with another form of payment.',
      [lblGCRecaptchaFailed]: 'Please try again',
      [lblErrGCSvs20]: GIFTCARD_AUTHORIZATION_FAILED,
      [lblPaypalCcAuthenticationUserCanc]: 'User canceled session when logged in to PayPal.',
      [lblPaypalCcGenericError]:
        'Oops... there was an issue with your PayPal payment. Please try again.',
      [lblPaypalCcFailedTransTable]:
        'Oops... there was an issue with your PayPal payment. Please try again.',
      [lblCardinalCommerceError]:
        'Oops... Your city, state, and zip code do not match. Please update your address on the shipping step.',
      [lblTcpMixOrderNotAcceptedNow]: 'System does not accept MIX orders now.',
      [lblTcpBopisOrderNotAcceptedNow]:
        'Sorry, pick up in store is currently unavailable. Please go back to your shopping bag to ship or remove the items.',
      [lblInvalidParam]: 'element will have name of parameter having problem.',
      [lblMandatoryParamNotPassed]: 'one of the mandatory parameters not passed.',
      [lblErrBagParams]:
        "Sorry, we couldn't find an account associated with that email address. Please try again.",
      [lblOosOrUnavailable]:
        'Some of the item(s) in your bag are either sold out or need updating. Continuing with checkout will remove them from your bag.',
      [lblErrorMessagesSvs07]:
        'Sorry, the gift card entered does not have an available balance. Please enter a new gift card or select a new payment type.',
      [lblErrorMessagesSvs08]: GIFTCARD_AUTHORIZATION_FAILED,
      [lblTcpErrorCodeCardDeclined]: GIFTCARD_AUTHORIZATION_FAILED,
      [lblErrorMessagesDefault]: 'Oh no! Something went wrong… Please try again in a few minutes.',
      [lblTcpPaymentProcessingErr]:
        'We are sorry, however we are unable to obtain authorization to charge this credit card. Please try again with an another form of payment.',
      [lblDbgApiDoPaymentBadXdate]:
        'Uh oh... It looks like the credit card has expired. Please update or add a new card.',
      [lblErrTaxwareUtlGeneralCc]:
        'Sorry, we are having difficulty calculating the tax. This may be a system error or an issue with the address provided. Please confirm and try again.',
      [lblCodeNotApplicable]:
        'Coupon is not applicable. Note: If you are applying a My Place Rewards Credit card coupon, coupon will not apply until your card has been entered at checkout.',
      [lblCodeNotApplicableCa]: 'Coupon not applicable.',
      [lblErrUsZipcodeInvalid]: 'Please enter a valid postal code',
      [lblErrTaxwareUtlRc]:
        'Sorry, we are having difficulty calculating the tax. This may be a system error or an issue with the address provided. Please confirm and try again.',
      [lblErrorMessagesTcp06]:
        'Please enter a gift card in US Dollars or use another form of payment.',
      [lblErrorMessagesTcp07]:
        'Please enter a gift card in Canadian Dollars or use another form of payment.',
      [lblInternalServerError]: 'Oops... There was an issue, please try again.',
      [lblErrInternalServerError]: 'There was a problem logging out. Please try again.',
      [lblErrorMessagesCWXFR0230E]: 'Oops, something went wrong. Please retry!',
      [lblDomHistoryErrorDetected]:
        'We are sorry, your order history is not available at this time. Please try again later.',
      [lblErrRdnAlreadyExist]:
        'The email address you provided matches an existing account. Please try another email address.',
      [lblAssociateIdNotExist]:
        'The employee id you entered does not exist. Type a different employee id and try again.',
      [lblAssociateIdDoesNotExist]:
        'The Associate ID you entered does not exist. Please try again.',
      [lblAssociateIdNotValid]:
        "The Associate ID you entered doesn't match the name in our records. Please try again.",
      [lblAssociateIdNotExistForUser]:
        'The Associate ID you entered does not exist. Please try again.',
      [lblInvalidCurrentPwd]: 'Please check the password & try again',
      [lblErrMaxLimitReached]: 'A maximum of five payment methods may be saved to your account.',
      [lblInvalidPrescreenCode]: 'INVALID_PRESCREEN_CODE',
      [lblErrorMessages13007]: 'INVALID_PRESCREEN_CODE',
      [lblMyAccountPointsClaim2]: 'Names do not match Credit Card.',
      [lblMyAccountPointsClaim3]: 'No Transaction Found.',
      [lblMyAccountPointsClaim4]: 'Transaction already assigned a MyplaceID.',
      [lblSystemNotAvailable]: 'We are unable to process your request. Please try again later.',
      [lblErrOrdEmailMismatch]: 'Sorry, that order was not found. Please try again.',
      [lblErrorMessagesTCPBPO01]: 'Sorry... Pickup in store is not currently available in Canada.',
      [lblBopisNotAvailable]: 'Sorry... Pickup in store is not currently available in Canada.',
      [lblNoStoresFound]: "Sorry... We couldn't find a store within your search parameters.",
      [lblErrSomethingWrong]: 'Something went wrong. Please check your details and try again.',
      [lblErrorOccured]: 'Cannot share for more than 5 users.',
      [lblErrGiftListNameTooLong]: 'Wishlist titles cannot be over 68 characters. Please rename.',
      [lblErrItemCatelogEntryNotFound]: 'Sorry, we are unable to add this item to your wishlist.',
      [lblErrorMessagesOobError]: OOS_ERR_MESSAGE,
      [lblWicRtpsCouponNotApplied]:
        'We attempted to apply your offer, but, it does not combine with offers already applied to your order. We’ve saved your coupon to your My Place Rewards account.',
      [lblRtpsInactivePayment]:
        'Sorry, there was an issue with your payment. Please re-enter your payment information and try again.',
      [lblCvvRequestFailedWithCvvError]:
        'We are sorry, however we are unable to obtain authorization to charge this credit card. Please try again with another form of payment.',
      [lblErrCredentialsExpired]: 'User name / password did not match.',
      [lblCvvRequestFailedWithAuthError]:
        'The payment method entered could not be authorized for this purchase. Please review the information entered and try again or try an alternate form of payment',
      [lblInvalidRecaptcha]: 'Please re-check the recaptcha value.',
      [lblEmptyRecaptcha]: 'Please check the recaptcha value.',
      [lblTcpPaymentInsufficient]: 'There was a problem processing your payment, please try again.',
      [lblErrmaxItemcount]: 'You have exceeded the maximum number of items in your wishlist.',
      [lblErrInvalidAddr]:
        'Sorry, there was an issue. This may be an issue with the address provided. Please confirm and try again.',
      [lblErrorMessagesVidesErrro1]: 'Your mobile number is already subscribed.',
      [lblErrorMessagesVidesErrro2]: 'Please enter a valid phone number.',
      [lblTcpPromotionCouponExpired]:
        'The coupon applied to your order ${errorParameters} is not valid.  Please check coupon validity dates.',
      [lblCouponGeneric]: 'This offer cannot be applied.',
      [lblPromotionNotAvailableThisTime]:
        '<p style="color: #c8102e; font-family: Nunito; font-size: 12px;">Sorry, ${errorParameters} could not be applied. Please review the redemption dates.</p>',
      [lblErrMoreThan15ItemsInCart]: 'Max quantity reached. Select another color or size.',
      [lblApiCantResolveFemcenter]:
        'Sorry, one or more items you are trying to purchase are either out of stock or not available in the quantity you requested. Please go back to bag to confirm availability.',
      [lblApiBadInv]:
        'One or more items in your bag are unavailable for your selected options. Please update your bag.',
      [lblApiBadInvCheckout]: 'There is insufficient inventory to fulfill your request',
      [lblVenmoGeneralErr]:
        'The payment method entered could not be authorized for this purchase.  Please review the information entered and try again or try an alternate form of payment',
      [lblTcpAuthRequestFailedAvs]:
        'The payment entered could not be authorized for this purchase. Please review your credit card and billing information and try again.',
      [lblApiCartOosItem]:
        'Sorry, one or more items you are trying to purchase are either out of stock or not available in the quantity you requested. Please go back to bag to confirm availability.',
      [lblProcessRequestError]: 'There was an error processing your request.',
      [lblAddressNotEligible]: 'The address is not eligible for application',
      [lblNoAddAvailable]: 'The address is not available.',
      [lblErrorMessages9001]: 'Save more by creating a new list or buying current items',
      [lblErrMoreThan300Total]: "can't add more than 300 items to cart.",
      [lblTcpSflMaxLimitError]:
        'Sorry you have reached the max number of items that can be saved for later.',
      [lblGiftCardInsufficientFund]: 'There is no balance for the account provided.',
      [lblErrorMessagesSvs04]: GIFTCARD_AUTHORIZATION_FAILED,
      [lblBopisDomInvUnavailable]: OOS_ERR_MESSAGE,
      [lblQvSorryMessage]: 'System Error',
      [lblQuickViewError]:
        'Your action could not be completed due to a system error. Please try again later',
      [lblErrResendOrderEmail]: 'Please enter valid email address',
      [lblErrResendOrderNotFound]:
        'This order is no longer eligible to resend the order confirmation.',
      [lblErrResendConfirmationLimitReached]: 'Order confirmation resend limit has been reached.',
      [lblErrBenefitsNotApplicable]:
        'We removed one or more non-applicable benefits in your basket. Please resubmit the order',
      [lblErrStateDoesNotMatchShipmentOption]:
        'User need to select different shipment option. Selected shipment option is not available in this state.',
      [lblTcpPromotionCouponAlreadyUsed]:
        'Coupon code has been used. Please check the code and try again.',
      [lblTcpPromotionPlaceCashCouponExpired]:
        'This place cash coupon has expired. See redemption dates.',
      [lblTcpPromotionCouponEmptyCart]: 'Add an item to your Bag before applying coupon code.',
      [lblTcpEmptyCartBenefitsCoupon]: 'Add an item to your Bag before applying the offer',
      [lblTcpPromotionPlccAvailableAdsplacecardUser]:
        'Please select your My Place Rewards Credit Card as payment to apply this coupon',
      [lblErrInvalidCity]: 'Please enter a valid city name.',
      [lblApiCantResolveFfmcenterShort]: NOT_AVAILABLE_MSG,
      [lblErrorOccuredTryAgain]: 'AN ERROR OCCURRED PLEASE TRY AGAIN',
      [lblEnterValidExpirationDate]: 'PLEASE ENTER A VALID EXPIRATION DATE AND TRY AGAIN',
      [lblTryLoggingInAgain]:
        'Seems like we ran into a hiccup. Try logging out and then log back in, or try again later. If the problem persists, contact us.',
      [lblAfterpayCheckoutError]:
        'There was a problem processing your Afterpay payment, please try again or choose another payment method.',
      [lblBtsErrorMsgHeader]: 'OOPS!',
      [lblAfterpayCheckoutGcError]:
        'Afterpay is unavailable for gift card purchases. Please select a new payment method.',
      [lblApiCantResolveFfmCenterOos]: 'Sorry this item is out of stock!',
      [lblApiCantResolveFfmPartialInstockMsg1]: 'The quantity you requested is not available. Only',
      [lblApiCantResolveFfmPartialInstockMsg2]: 'quantity is available',
      [lblParamCatIdBossIneligible]: OOS_ERR_MESSAGE,
      [lblUsidUnauthorized]:
        "Your session has timed out, and we've encountered a problem with this action. Please try again",
      [lblTcpPromotionLoyaltyNotMet]:
        'Your item total is $<CODE_PLACEHOLDER> away from being able to redeem this reward',
      [lblTcpPromotionPlaceCashNotMet]:
        'Your item total is $<CODE_PLACEHOLDER> away from being able to redeem this place cash coupon, Please note, clearance items are excluded.',
      [lblErrBillingAddressMissing]: 'Please review payment method info and try again',
      [lblErrBillingAddressInternationalPlcc]:
        'Please enter a billing address in the United States for your My Place Rewards credit card.',
      [lblErrAddEditCreditCard]:
        'Unable to save card. Please check the card number, CVV and expiration date and try again, or use a different payment method.',
      [lblInsufficientInventoryCode]:
        'One or more items in your bag are unavailable for your selected options. Please update your bag.',
      [lblMobileAppCodeNotApplicable]: 'Coupon not applicable. Valid on mobile app orders only.',
      [lblAppliedMobileCodeNotApplicable]: 'Coupon not applied. Valid on mobile app orders only.',
      [lblErrInvalidProductItem]: NOT_AVAILABLE_MSG,
      [lblErrProductItemNotFound]: NOT_AVAILABLE_MSG,
      [lblErrInvalidShippingMethodId]:
        'Shipping method selected is not supported for this address. Please re-enter the address and try again!',
      [lblErrBasketQuotaExceeded]: 'You have reached max number of items you can order.',
      [lblErrMaxShipmentsReached]:
        'Maximum number of store shipments reached. Please use one of the existing store pickup shipment to proceed further.',
      [lblApplePayCouponNotApplicable]:
        'APPLEPAY coupon not applied. Please pay with Apple Pay or remove the coupon and try again.',
      [lblErrPromotionCodeValueCuplicateOnhold]:
        'This coupon is already applied. Discount will be taken when minimum cart total has been reached.',
      [lblBossInvNotApplicable]:
        'This item is not currently eligible for Buy Online Ship to Store and was not added to your bag. Check out our similar styles!',
      [lblErrInvNotApplicable]:
        'The items in your bag are unavailable for #methodName. Please continue with the current fulfillment method.',
      [lblErrorMessagesTimeout]:
        'Oh no! Something went wrong, possibly due to a slow internet connection. Please try again.',
      [lblErrFailedTriggeringUserSharecart]: 'Something went wrong...',
      [lblErrShareCartItemsOos]:
        'Shared items are no longer in stock. Select cancel to go to the homepage.',
      [lblErrShareCartGetItemsFailed]: 'Oops! Something went wrong, please try again.',
      [lblErrFailedShareCartNoId]: 'This shared cart has expired.',
      [lblPaypalAddressError]:
        'To continue with PayPal, your city, state and zip code must match. Please correct your address in the shipping step of checkout and try again.',
    },
  },
};
